<template>
  <f7-list accordion-list v-if="documents" id="payments-item-received" class="itemList">
    <f7-accordion-item class="accordionForm"
      v-for="document in documents"
      :key="document.id"
      @accordion:opened="readReport(document)">
      <f7-accordion-toggle class="accordionToggle">
        <ul>
          <li class="swipeout">
            <div class="item-content boxRequest">
              <div class="item-media">
                <div id="greenRectangle" :style="{background: rectangleColor}"></div>
                <i class="icon list-icon" v-bind:class="getIcon(document.Status)"></i>
              </div>
              <div class="item-inner">
                <table width="100%" style="table-layout: fixed;">
                  <tr>
                    <td style="width: 35%; min-width: 35%; max-width: 35%;">
                      <div style="font-weight: bold;">
                        {{ getDocumentLabel(document) }}
                      </div>
                    </td>
                    <td style="width: 35%; min-width: 35%; max-width: 35%;" class="showLargeScreenOnly">
                      {{ getDocumentType(document) }}
                    </td>
                    <td style="width: 30%; min-width: 30%; max-width: 30%;" class="showLargeScreenOnly">
                      {{ getDate(document) }}
                    </td>
                  </tr>
                  <tr class="documentListUnderTitle">
                    <td width="20%">
                      <span class="showSmallScreenOnly">
                        {{ getDocumentType(document) }}
                      </span>
                      <span class="showLargeScreenOnly">
                        {{ getStatusLabel(document.Status, document.Role) }}
                      </span>
                    </td>
                    <td class="showLargeScreenOnly">
                      {{ document.Role.toString() === '1' ? $t('common.to_label') : $t('common.from_label') }}
                      {{ ' : ' + document.Correspondent }}
                    </td>
                    <td rowspan="2" style="font-size: 14px;">
                      <div style="display:flex;" v-if="showValidationButtons(document.Status, document.Role)">
                        <!-- associated right:  v-if="$engine.rights.rightIs('ds_request_response_accepter', true)"-->
                        <div class="documentButton"
                          @click="updateDecision($event, document, 'ACCP')">
                          <i class="icon list-icon icon-accept-doc"></i>
                          {{ $t('common.accpt') }}
                        </div>
                        &nbsp;
                        <!-- <div class="documentButton documentButtonCenter" @click="redirectNego">
                          <i class="icon list-icon icon-negotiate-doc"></i>
                          {{ $t('common.negotiate') }}
                        </div> -->
                        <!-- associated right: v-if="$engine.rights.rightIs('ds_request_response_refuser', true)"-->
                        <div class="documentButton"
                          @click="updateDecision($event, document, 'RFSL')">
                          <i class="icon list-icon icon-reject-doc"></i>
                          {{ $t('common.refus') }}
                        </div>
                      </div>
                      <div style="display:flex;" v-if="showValidationButtonsLevel2(document.Status)">
                        <div class="documentButton"
                          @click="updateDecisionLevel2($event, document, 'ACCP')">
                          <i class="icon list-icon icon-accept-doc"></i>
                          {{ $t('common.accpt') }}
                        </div>
                        &nbsp;
                        <div class="documentButton"
                          @click="updateDecisionLevel2($event, document, 'RFSL')">
                          <i class="icon list-icon icon-reject-doc"></i>
                          {{ $t('common.refus') }}
                        </div>
                      </div>
                      <div style="display:flex;" v-if="showPayButtons(document.Status, document.Role, document.Type)">
                        <!-- associated right:  v-if="$engine.rights.rightIs('ds_request_response_accepter', true)"-->
                        <div class="documentButton"
                          @click="payInvoice(document)">
                          <i class="icon list-icon icon-hand_money"></i>
                          {{ "Payer la facture" }}
                        </div>
                        &nbsp;
                        <div class="documentButton"
                          @click="closeDocument($event, document)">
                          <i class="icon list-icon icon-made"></i>
                          {{ "Facture payée" }}
                        </div>
                      </div>
                      <div style="display:flex;" v-if="showClosingDocButtons(document.Status, document.Role, document.Type)">
                        <div class="documentButton"
                          @click="closeDocument($event, document)">
                          <i class="icon list-icon icon-made"></i>
                          {{ "Facture payée" }}
                        </div>
                      </div>
                      <div style="display:flex;" v-else-if="showReturningDocButtons(document.Status, document.Role)">
                        <div class="documentButton" v-if="$engine.rights.rightIs('ds_send_document', true)">
                          <i class="icon list-icon icon-return-doc"></i>
                          {{ $t('businessDocuments.form_document_send_title') }}
                        </div>
                        <div class="documentButton" v-if="$engine.rights.rightIs('ds_request_response_refuser', true)"
                          style="margin-left: 27px;" @click="updateDecision($event, document, 'RFSL')">
                          <i class="icon list-icon icon-reject-doc"></i>
                          {{ $t('common.refus') }}
                        </div>
                      </div>
                      <div style="display:flex;" v-else-if="showAfterCancelDocButtons(document.Status, document.Role)">
                        <div class="documentButton" style="margin-left: -20px;"
                          @click="resendRequest(document)">
                          <i class="icon list-icon icon-return-doc"></i>
                          {{ $t('businessDocuments.form_document_resend_request_title') }}
                        </div>
                      </div>
                      <div style="display:flex;">
                        <div class="documentButton" @click="createReminder($event, document)">
                          {{ "Create Reminder" }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="detailsDocumentStatus showSmallScreenOnly">
                      {{ getStatusLabel(document.Status, document.Role) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="showSmallScreenOnly" colspan="4">
                      {{ getDate(document) }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </li>
        </ul>
      </f7-accordion-toggle>
      <f7-accordion-content class="background-document-form left-box" v-if="document.Serialize">
        <!-- Form displayed if the user has to return a file -->
        <business-document-return-form v-if="showReturningDocButtons(document.Status, document.Role)"
                                       :document="document"
                                       :cloudDocs="cloudFilesList"
                                       @reloadFolder="getDocumentDetails(document.IdDocument)">
        </business-document-return-form>
        <business-document-details-list v-else :document="document">
        </business-document-details-list>
      </f7-accordion-content>
    </f7-accordion-item>
  </f7-list>
</template>
<script>
import BusinessDocumentDetailsList from '@/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentDetailsList.vue'
import BusinessDocumentReturnForm from '@/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentReturnForm.vue'
import documentSerialize from '@/helpers/documentSerialize.json'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import rfslCodes from '@/pages/requests/detailPages/businessDocumentDetailPages/data/rsflCodes.json'
import Services from '@/helpers/services'
import status from '@/helpers/status'
import {statusLabel, statusIcon} from '@/helpers/labels'

export default {
  name: 'BusinessDocumentList',
  props: ['documents', 'filterBy'],
  components: {
    'business-document-details-list': BusinessDocumentDetailsList,
    'business-document-return-form': BusinessDocumentReturnForm
  },
  data () {
    return {
      canceledDocumentStatusList: [
        status.DOC_CANCELED,
        status.DOC_EXPIRED,
        status.DOC_REFUSED,
        status.DOC_REJECTED,
        status.DOC_REQUEST_CANCELED,
        status.DOC_REQUEST_OUT_TIME,
        status.DOC_REQUEST_REFUSED,
        status.DOC_REQUEST_REJECTED
      ],
      cloudFilesList: {},
      // Utilisé pour le statut DOC_CLOSED
      // Statuts desquels il est possible de fermer l'échange
      documentClosedDocStatusList: [
        status.DOC_CLOSING,
        status.DOC_EXPIRED,
        status.DOC_NEGOTIATION_ACCEPTED,
        status.DOC_NEGOTIATION_REVOKED,
        status.DOC_READ,
        status.DOC_RECEIVED,
        status.DOC_REQUEST_ACCEPTED,
        status.DOC_REQUEST_OUT_TIME,
        status.DOC_SENT,
        status.DOC_VALIDATED,
        status.DOC_VALIDATED_MAN
      ],
      // Statuts desquels il est possible de demander la fermeture de l'échange
      documentClosingDocStatusList: [
        status.DOC_EXPIRED,
        status.DOC_NEGOTIATION_ACCEPTED,
        status.DOC_NEGOTIATION_RECEIVED,
        status.DOC_NEGOTIATION_SENT,
        status.DOC_REQUEST_OUT_TIME,
        status.DOC_REQUEST_READ,
        status.DOC_REQUEST_RECEIVED,
        status.DOC_REQUEST_SENT,
        status.DOC_VALIDATED,
        status.DOC_VALIDATED_MAN
      ],
      // Statuts qui peuvent passer au statut lu
      documentReadDocStatusList: [
        status.DOC_RECEIVED,
        status.DOC_SENT
      ],
      // Statuts qui peuvent passer au statut demande lue
      documentReadRequestDocStatusList: [
        status.DOC_REQUEST_RECEIVED,
        status.DOC_REQUEST_SENT
      ],
      documentRecvDocStatusList: [
        status.DOC_EXPIRED,
        status.DOC_NEGOTIATION_RECEIVED,
        status.DOC_NEGOTIATION_REVOKED,
        status.DOC_READ,
        status.DOC_RECEIVED,
        status.DOC_REQUEST_SENT
      ],
      documentReturnDocStatusList: [
        status.DOC_REQUEST_READ,
        status.DOC_REQUEST_RECEIVED
      ],
      documentSendDocStatusList: [
        status.DOC_NEGOTIATION_REVOKED,
        status.DOC_NEGOTIATION_SENT,
        status.DOC_REFUSED,
        status.DOC_REQUEST_READ,
        status.DOC_REQUEST_RECEIVED,
        status.DOC_SENT,
        status.DOC_VALIDATED
      ],
      // Statuts de clôture
      documentCloseDocStatusList: [
        status.DOC_CLOSED,
        status.DOC_CLOSING
      ],
      invoice: [
        'INVOICE',
        'FACTUR-X'
      ],
      noActionDocumentStatusList: [
        status.DOC_INITIALIZED,
        status.DOC_PAID,
        status.DOC_REQUEST_SENT,
        status.DOC_SENT,
        status.DOC_THIRD_PARTY_RECEIVED,
        status.DOC_THIRD_PARTY_REFUSED,
        status.DOC_THIRD_PARTY_REJECTED,
        status.DOC_THIRD_PARTY_SENT,
        status.DOC_THIRD_PARTY_VALIDATED,
        status.DOC_VALIDATED,
        status.DOC_VALIDATED_MAN
      ],
      rectangleColor: this.$engine.services.getServiceColor(this.$engine.user.currentService.id),
      sharedFoldersConfig: this.$engine.services.businessDocuments.sharedFoldersConfig
    }
  },
  created () {
    // getting cloud files for all the business-document-return-form at once
    this.getCloudFilesList()
  },
  methods: {
    closeDocument (e, document) {
      e.stopPropagation()
      let that = this
      let action = 'CLSD'
      if (document.Role.toString() === '0') {
        action = 'CLSG'
      }
      if (this.isInvoice(document.Type)) {
        this.$f7.modal({
          cssClass: 'modal-2 text-left',
          title: this.$i18n.t('businessDocuments.close_invoice_confirmation'),
          text: action === 'CLSD' ? this.$i18n.t('businessDocuments.closed_invoice_comment') : this.$i18n.t('businessDocuments.closing_invoice_comment'),
          buttons: [
            {
              text: this.$i18n.t('common.cncl'),
              onClick: function () {}
            },
            {
              text: this.$i18n.t('common.confirm'),
              onClick: function () {
                that.sendDecisionUpdate(document, action, that.Dom7('.confirmDocument').val())
              }
            }
          ]
        })
      } else {
        this.$f7.modal({
          cssClass: 'modal-2 text-left',
          title: this.$i18n.t('businessDocuments.close_doc_confirmation'),
          text: action === 'CLSD' ? this.$i18n.t('businessDocuments.closed_doc_comment') : this.$i18n.t('businessDocuments.closing_doc_comment'),
          buttons: [
            {
              text: this.$i18n.t('common.cncl'),
              onClick: function () {}
            },
            {
              text: this.$i18n.t('common.confirm'),
              onClick: function () {
                that.sendDecisionUpdate(document, action, that.Dom7('.confirmDocument').val())
              }
            }
          ]
        })
      }
    },
    createReminder (e, document) {
      e.stopPropagation()
      let jsonToCreateAcceptRefuse = {
        hasTransaction: '1',
        idTransaction: document.IdDocument.toString(),
        serviceTransaction: this.$engine.user.currentService.id,
        message: 'Fais un choix',
        freqHour: 1,
        freqDay: 0,
        freqWeek: 0,
        freqMonth: 0,
        freqYear: 0,
        stopAfterOccurrences: 1,
        isNotifyEmail: 0,
        isNotifySms: 0
      }
      this.$engine.reminders.create(jsonToCreateAcceptRefuse)
      let jsonToCreatePayment = {
        hasTransaction: '1',
        idTransaction: document.IdDocument.toString(),
        serviceTransaction: this.$engine.user.currentService.id,
        message: 'Test relance',
        freqHour: 1,
        freqDay: 0,
        freqWeek: 0,
        freqMonth: 0,
        freqYear: 0,
        stopAfterOccurrences: 1,
        isNotifyEmail: 0,
        isNotifySms: 0,
        isStopped: 1
      }
      this.$engine.reminders.create(jsonToCreatePayment)
    },
    getCloudFilesList () {
      // this.$engine.attachments.getRefresh({
      //   idAcct: this.$engine.user.get().id
      // }).then(response => {
      //   let filesMap = response.data.docs.map(function (obj) {
      //     let rObj = {}
      //     rObj[obj.name] = {
      //       id: obj.id,
      //       name: obj.name
      //     }
      //     return rObj
      //   })
      //   let filesMapObj = Object.assign({}, ...filesMap)
      //   this.cloudFilesList = filesMapObj
      // })
      // .catch(err => {
      //   errorMessageAlert(err, this)
      // })
    },
    getDate (document) {
      if (document.Type === 'ACTE') {
        return this.$i18n.t('businessDocuments.received_on') + ' ' + this.$options.filters.formatDate(document.DocumentDate)
      }
      if (this.documentRecvDocStatusList.includes('Doc_' + document.Status) && document.Role.toString() === '0' ||
          this.documentSendDocStatusList.includes('Doc_' + document.Status) && document.Role.toString() === '1') {
        return this.$i18n.t('businessDocuments.last_update_on') + ' ' + this.$options.filters.formatDate(document.LastUpdateDate)
      }
      return this.$i18n.t('businessDocuments.last_update_on') + ' ' + this.$options.filters.formatDate(document.LastUpdateDate)
    },
    getDocumentDetails (documentId) {
      let that = this
      this.$engine.services.businessDocuments.getDocumentDetails(documentId)
      .then(resp => {
        that.documents[that.documents.map(function (e) { return e.IdDocument }).indexOf(resp.data.Documents[0].IdDocument)] = resp.data.Documents[0]
        that.$forceUpdate()
        // that.activateSpinner = false
        // that.detailsDone = true
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getDocumentLabel (document) {
      // if (this.documentRequestStatusList.includes('Doc_' + document.status)) {
      //   return this.$i18n.t('businessDocuments.business_doc_request')
      // }
      return document.Name
    },
    getDocumentType (document) {
      return this.$i18n.t(documentSerialize[document.Type].label)
    },
    getFolderInfo () {
      this.$emit('get-folder-info')
    },

    getIcon (status) {
      return statusIcon('Doc_' + status)
    },
    getStatusLabel (status, role) {
      return statusLabel(this.$i18n, 'Doc_' + status, role, -1, -1, this.$engine.user.userAccountId)
    },
    isInvoice (type) {
      if (this.invoice.includes(type)) {
        return true
      }
      return false
    },
    payInvoice (document) {
      console.log('HEYHEY')
      const { DocumentIdentifier, IdDocument, Reference, Type } = document
      this.$engine.services.businessDocuments.setTempDocument({ DocumentIdentifier, IdDocument, Reference, Type })
      new Promise(resolve => {
        this.$bus.$emit('service:change', 'Direct Payments')
        this.$bus.$emit('direct-inbox-filtered', 1)
        this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
        this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
        resolve(Services.DIRECTPAYMENTS)
      }).then(resolve => {
        console.log('CHANGE: ', resolve)
        loadPage(this, {url: '/directPayments/creation/'})
      })
    },
    readReport (document) {
      if (this.documentReadDocStatusList.includes('Doc_' + document.Status) && document.Role.toString() === '0' ||
          this.documentReadRequestDocStatusList.includes('Doc_' + document.Status) && document.Role.toString() === '1') {
        this.sendDecisionUpdate(document, 'READ', this.Dom7('.confirmDocument').val())
      }
    },
    redirectNego () {
      loadPage(this, {url: '/businessDocument/negotiate'})
    },
    resendRequest (document) {
      this.$f7.showPreloader(this.$i18n.t('loading.sending_document_request'))
      let that = this
      let jsonToCreate = {}

      if (document.Type === 'ACTE') {
        let id = document.Name.split('_')[1]
        jsonToCreate = {
          Receiver: document.Correspondent,
          SIREN: id, // document.name
          AttachmentId: document.DocumentIdentifier,
          AttachmentRequestName: document.Name,
          IdGroup: document.IdGroup,
          GroupId: document.GroupId,
          GroupLabelReference: document.GroupReference
        }
        that.$engine.services.businessDocuments.createAPI(jsonToCreate)
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$i18n.t('success.document_request_sent'),
              text: '<i class="icon fa fa-check"></i>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              that.getFolderInfo()
              that.getDocumentDetails(document.IdDocument)
              // loadPage(that, {url: '/inbox/'})
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        jsonToCreate = {
          Receiver: document.Correspondent,
          AttachmentId: document.DocumentIdentifier,
          AttachmentRequestType: document.Type,
          AttachmentRequestName: document.Name,
          AttachmentRequestDescription: document.Description,
          AttachmentOthers: document.Serialize,
          IdGroup: document.IdGroup,
          GroupId: document.GroupId,
          GroupLabelReference: document.GroupReference
        }
        that.$engine.services.businessDocuments.create(jsonToCreate)
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$i18n.t('success.document_request_sent'),
              text: '<i class="icon fa fa-check"></i>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              that.getFolderInfo()
              that.getDocumentDetails(document.IdDocument)
              // reloadPage(that, {url: '/inbox/', force: true, ignoreCache: true})
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    sendDecisionUpdate (document, action, decisionMessage = '') {
      let that = this
      let paramsToSend = {
        Receiver: document.Correspondent,
        AttachmentId: document.DocumentIdentifier,
        AttachmentName: document.Name,
        TransactionStatus: action,
        DecisionMessage: decisionMessage
      }
      if (this.sharedFoldersConfig) {
        paramsToSend.GroupId = this.$engine.services.businessDocuments.currentSendbox.idgroup
        paramsToSend.IdDocument = document.id
      }
      this.$engine.services.businessDocuments.decide(paramsToSend)
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: this.$i18n.t('businessDocuments.updated_doc'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.getFolderInfo()
            that.getDocumentDetails(document.IdDocument)
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    sendDecisionUpdateLevel2 (document, action, decisionMessage = '') {
      let that = this
      let paramsToSend = {
        Receiver: this.$engine.user.get().identifier,
        AttachmentId: document.DocumentIdentifier,
        AttachmentName: document.Name,
        TransactionStatus: action,
        DecisionMessage: decisionMessage,
        IdDocument: document.IdDocument
      }
      this.$engine.services.businessDocuments.updateDocument(paramsToSend)
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: this.$i18n.t('businessDocuments.updated_doc'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.getFolderInfo()
            that.getDocumentDetails(document.IdDocument)
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    // showing buttons for any action if the document has been canceled
    showAfterCancelDocButtons (documentStatus, role) {
      if (this.canceledDocumentStatusList.includes('Doc_' + documentStatus) &&
          role.toString() === '0' &&
          this.$engine.rights.rightIs('ds_send_request_document', true)) {
        return true
      }
      return false
    },
    showClosingDocButtons (documentStatus, role, type) {
      if ((this.documentClosingDocStatusList.includes('Doc_' + documentStatus) && role.toString() === '0' && !this.showPayButtons(documentStatus, role, type)) ||
          (this.documentClosedDocStatusList.includes('Doc_' + documentStatus) && role.toString() === '1')) {
        return true
      }
      return false
    },
    showPayButtons (documentStatus, role, type) {
      return status.DOC_VALIDATED === 'Doc_' + documentStatus && role.toString() === '0' && (type === 'INVOICE' || type === 'FACTUR-X')
    },
    // showing buttons for returning a document, if a document is requested
    // associated right: 'ds_send_document'
    showReturningDocButtons (documentStatus, role) {
      return this.documentReturnDocStatusList.includes('Doc_' + documentStatus) && role.toString() === '1'
    },
    // Showing Validate, Negotiatie or Refuse Buttons if the document is sent and not canceled
    showValidationButtons (documentStatus, role) {
      if ((this.documentSendDocStatusList.includes('Doc_' + documentStatus) && role.toString() === '0') ||
          (this.documentRecvDocStatusList.includes('Doc_' + documentStatus) && role.toString() === '1') ||
          this.canceledDocumentStatusList.includes('Doc_' + documentStatus) ||
          this.documentReturnDocStatusList.includes('Doc_' + documentStatus) ||
          this.noActionDocumentStatusList.includes('Doc_' + documentStatus) ||
          this.documentCloseDocStatusList.includes('Doc_' + documentStatus)) {
        return false
      }
      return true
    },
    // Showing Validate, Negotiatie or Refuse Buttons if the document is validated level 1
    showValidationButtonsLevel2 (documentStatus) {
      return this.$engine.user.userAccountId === '16' && documentStatus === 13
    },
    updateDecision (e, document, action) {
      e.stopPropagation()
      let that = this
      that.$f7.modal({
        cssClass: 'modal-2 text-left',
        title: action === 'RFSL' ? that.$i18n.t('businessDocuments.refuse_doc_confirmation') : that.$i18n.t('businessDocuments.accept_doc_confirmation'),
        text: action === 'RFSL' ? that.$i18n.t('businessDocuments.refuse_comment_indication')
              : (this.isInvoice(document.Type) ? that.$i18n.t('businessDocuments.accept_comment_indication_invoice') : that.$i18n.t('businessDocuments.accept_comment_indication')),
        afterText: action === 'RFSL' ? '<div class="item-input"><textarea class="confirmDocument commentTextArea"></textarea></div>'
                  : (this.isInvoice(document.Type) ? '<br><input type="date" class="datePicker">'
                  : '<div class="item-input"><textarea class="confirmDocument commentTextArea"></textarea></div>'),
        buttons: [
          {
            text: that.$i18n.t('common.cncl'),
            onClick: function () {
            }
          },
          {
            text: action === 'RFSL' ? that.$i18n.t('common.refus') : that.$i18n.t('common.accpt'),
            onClick: function () {
              let date = that.Dom7('.datePicker').val()
              let reason = that.Dom7('.confirmDocument').val()
              if (date && action === 'ACCP') {
                that.sendDecisionUpdate(document, action, date)
              } else if (reason && action === 'RFSL') {
                that.sendDecisionUpdate(document, action, reason)
              } else if (action === 'RFSL') {
                that.$f7.alert(that.$i18n.t('errors.refusal_reason_required_comment'), that.$i18n.t('errors.required_field'))
              } else if (that.isInvoice(document.Type)) {
                that.$f7.alert(that.$i18n.t('errors.estimated_date_required_comment'), that.$i18n.t('errors.required_field'))
              } else {
                that.sendDecisionUpdate(document, action, reason)
              }
            }
          }
        ]
      })
    },
    updateDecisionLevel2 (e, document, action) {
      e.stopPropagation()
      let that = this
      let options = ''
      let type = document.Type
      let rfslCodesType = rfslCodes[type]
      let modalText = ''

      for (let id in rfslCodesType) {
        let label = that.$i18n.t('common.rfsl.' + type + '.s_' + rfslCodesType[id])
        let value = that.$i18n.t('common.rfsl.' + type + '.l_' + rfslCodesType[id])
        options += '<option value="' + value + '">' + label + '</option>'
      }

      if (action === 'RFSL') {
        modalText = '<div>' +
                      '<span>Sélectionner un motif de refus :</span>' +
                      '<select id="selectCodeRefus" style="width:200px;">' +
                        options +
                      '</select>' +
                    '</div>'
      }

      that.$f7.modal({
        title: action === 'RFSL' ? that.$i18n.t('businessDocuments.refuse_doc_confirmation') : that.$i18n.t('businessDocuments.accept_doc_confirmation'),
        text: modalText,
        buttons: [
          {
            text: that.$i18n.t('common.cncl'),
            onClick: function () {}
          },
          {
            text: action === 'RFSL' ? that.$i18n.t('common.refus') : that.$i18n.t('common.accpt'),
            onClick: function () {
              that.sendDecisionUpdateLevel2(document, action, that.Dom7('#selectCodeRefus').val())
            }
          }
        ]
      })
    }
  }
}
</script>
